import { render, staticRenderFns } from "./ChatMessageItems.vue?vue&type=template&id=2e3acbf6&"
import script from "./ChatMessageItems.vue?vue&type=script&lang=js&"
export * from "./ChatMessageItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports